import { FormattedMessage } from "react-intl";
import { Heading, Skeleton, Text, tabularNumsClass } from "@lendcord/concord";

interface CreditorStatCardProps {
  labelId: string;
  value: string;
  showViewList?: boolean;
  onViewListClick?: () => void;
  // Mirrors @lendcord/concord's StatCard loading treatment — same h-9/w-28
  // skeleton footprint matching size="lg"'s line-height, no reflow.
  loading?: boolean;
}

export function CreditorStatCard({ labelId, value, showViewList, onViewListClick, loading = false }: CreditorStatCardProps) {
  return (
    <div className="rounded-md border border-border bg-surface-raised p-6 shadow-sm">
      <div className="flex items-center justify-between gap-2">
        <Text as="p" size="sm" variant="muted">
          <FormattedMessage id={labelId} />
        </Text>
        {showViewList && (
          <button
            type="button"
            onClick={onViewListClick}
            className="text-sm font-medium text-accent-600 hover:underline"
          >
            <FormattedMessage id="lender.creditor.viewListLink" />
          </button>
        )}
      </div>
      {loading ? (
        <Skeleton variant="text" className="mt-1 h-9 w-28" />
      ) : (
        <Heading as="p" size="lg" className={`mt-1 ${tabularNumsClass}`}>
          {value}
        </Heading>
      )}
    </div>
  );
}
